/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WordPressSignupCreateResponse
 */
export interface WordPressSignupCreateResponse {
    /**
     * The email address of the user that was created or found
     * @type {string}
     * @memberof WordPressSignupCreateResponse
     */
    email: string;
    /**
     * The domain name of the WordPress site
     * @type {string}
     * @memberof WordPressSignupCreateResponse
     */
    domain: string;
    /**
     * The WordPress admin URL
     * @type {string}
     * @memberof WordPressSignupCreateResponse
     */
    adminUrl: string;
    /**
     * WordPress integration version used
     * @type {string}
     * @memberof WordPressSignupCreateResponse
     */
    version: string;
    /**
     * Whether the signup was successful
     * @type {boolean}
     * @memberof WordPressSignupCreateResponse
     */
    success: boolean;
}

/**
 * Check if a given object implements the WordPressSignupCreateResponse interface.
 */
export function instanceOfWordPressSignupCreateResponse(value: object): value is WordPressSignupCreateResponse {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('adminUrl' in value) || value['adminUrl'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function WordPressSignupCreateResponseFromJSON(json: any): WordPressSignupCreateResponse {
    return WordPressSignupCreateResponseFromJSONTyped(json, false);
}

export function WordPressSignupCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WordPressSignupCreateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'domain': json['domain'],
        'adminUrl': json['adminUrl'],
        'version': json['version'],
        'success': json['success'],
    };
}

export function WordPressSignupCreateResponseToJSON(json: any): WordPressSignupCreateResponse {
    return WordPressSignupCreateResponseToJSONTyped(json, false);
}

export function WordPressSignupCreateResponseToJSONTyped(value?: WordPressSignupCreateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'domain': value['domain'],
        'adminUrl': value['adminUrl'],
        'version': value['version'],
        'success': value['success'],
    };
}

